import React from 'react';
import ReactGA from 'react-ga4';
import Theme from '../theme';
import Routes from '../routes';

import { AuthContextProvider } from '../contexts/Auth';
import { CurrentStepContextProvider } from '../contexts/CurrentStep';
import DetectStorage from '../components/DetectStorage';
import { ALLOW_BROWSERS } from '../utils/constants';
import { ThemeProvider } from '../contexts/Theme/themeProvider';

const {
  REACT_APP_GOOGLE_ANALYTICS,
} = process.env;

ReactGA.initialize(REACT_APP_GOOGLE_ANALYTICS);

const App = () => (
  <ThemeProvider>
    <Theme>
      <DetectStorage
        message="¡Aplicación no permitida!"
        subMessage="Por favor abre la página en las siguientes aplicaciones"
        allowBrowsers={ALLOW_BROWSERS}
      />
      <AuthContextProvider>
        <CurrentStepContextProvider>
          <Routes />
        </CurrentStepContextProvider>
      </AuthContextProvider>
    </Theme>
  </ThemeProvider>
);

export default App;
